import React, { useState } from 'react';
import '../styles/HelpMeChooseWizard.css';

const StepOccasion = ({ onNext }) => (
    <div className="wizard-step">
        <h3>What are you buying for?</h3>
        <div className="wizard-options">
            <button className="wizard-btn" onClick={() => onNext('daily')}>Daily Wear</button>
            <button className="wizard-btn" onClick={() => onNext('wedding')}>Wedding / Bridal</button>
            <button className="wizard-btn" onClick={() => onNext('party')}>Party / Festival</button>
            <button className="wizard-btn" onClick={() => onNext('gift')}>Gift</button>
            <button className="wizard-btn" onClick={() => onNext('investment')}>Investment</button>
        </div>
    </div>
);

const StepRecipient = ({ onNext }) => (
    <div className="wizard-step">
        <h3>Who is this for?</h3>
        <div className="wizard-options">
            <button className="wizard-btn" onClick={() => onNext('woman')}>Woman</button>
            <button className="wizard-btn" onClick={() => onNext('bride')}>Bride</button>
            <button className="wizard-btn" onClick={() => onNext('man')}>Man</button>
            <button className="wizard-btn" onClick={() => onNext('child')}>Child</button>
        </div>
    </div>
);

const StepBudget = ({ onNext }) => (
    <div className="wizard-step">
        <h3>💰 What's your budget?</h3>
        <div className="wizard-options">
            <button className="wizard-btn" onClick={() => onNext({ min: 0, max: 20000 })}>Under ₹20k</button>
            <button className="wizard-btn" onClick={() => onNext({ min: 20000, max: 50000 })}>₹20k - ₹50k</button>
            <button className="wizard-btn" onClick={() => onNext({ min: 50000, max: 100000 })}>₹50k - ₹1 Lakh</button>
            <button className="wizard-btn" onClick={() => onNext({ min: 100000, max: '' })}>Above ₹1 Lakh</button>
        </div>
    </div>
);

const HelpMeChooseWizard = ({ isOpen, onClose, onApplyFilters }) => {
    const [step, setStep] = useState(1);
    const [selections, setSelections] = useState({
        occasion: '',
        recipient: '',
        budget: { min: '', max: '' }
    });

    if (!isOpen) return null;

    const handleOccasion = (val) => {
        setSelections(prev => ({ ...prev, occasion: val }));
        setStep(2);
    };

    const handleRecipient = (val) => {
        setSelections(prev => ({ ...prev, recipient: val }));
        setStep(3);
    };

    const handleBudget = (val) => {
        const finalSelections = { ...selections, budget: val };
        // Logic to convert selections to filters
        const newFilters = {
            minPrice: finalSelections.budget.min,
            maxPrice: finalSelections.budget.max,
            // Map occasion/recipient to types or search queries
            search: `${finalSelections.occasion} ${finalSelections.recipient !== 'woman' ? finalSelections.recipient : ''}`.trim()
        };

        // For specific matches
        if (finalSelections.occasion === 'wedding') newFilters.type = 'set,necklace,bangle';
        if (finalSelections.recipient === 'man') newFilters.type = 'chain,ring';

        onApplyFilters(newFilters);
        onClose();
        setStep(1); // Reset for next time
    };

    return (
        <div className="wizard-overlay">
            <div className="wizard-container">
                <button className="wizard-close" onClick={onClose}>×</button>
                <div className="wizard-content">
                    <div className="wizard-progress">
                        <div className={`progress-dot ${step >= 1 ? 'active' : ''}`}></div>
                        <div className="progress-line"></div>
                        <div className={`progress-dot ${step >= 2 ? 'active' : ''}`}></div>
                        <div className="progress-line"></div>
                        <div className={`progress-dot ${step >= 3 ? 'active' : ''}`}></div>
                    </div>

                    {step === 1 && <StepOccasion onNext={handleOccasion} />}
                    {step === 2 && <StepRecipient onNext={handleRecipient} />}
                    {step === 3 && <StepBudget onNext={handleBudget} />}
                </div>
            </div>
        </div>
    );
};

export default HelpMeChooseWizard;
